import axiosInstance from "../utils/authUtils";
import { API_PATHS } from "../utils/constants/api.constants";

class BoothService {
  static async getBooths(params = {}) {
    const response = await axiosInstance.get(API_PATHS.getbooths, { params });
    return response.data;
  }

  static async getBoothById(id) {
    const response = await axiosInstance.get(`admin/booths/${id}`);
    return response.data;
  }

  static async createBooth(payload) {
    const response = await axiosInstance.post(API_PATHS.addbooth, payload);
    return response.data;
  }

  static async updateBooth(id, payload) {
    const response = await axiosInstance.put(`admin/booths/${id}`, payload);
    return response.data;
  }

  static async deleteBooth(id) {
    const response = await axiosInstance.delete(`admin/booths/${id}`);
    return response.data;
  }
}

export default BoothService;